// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autofit-ellipsis[data-v-4b5c313c]{height:100%}", ""]);
// Exports
module.exports = exports;
